import { ReactNode } from "react";

import { Box, Paper, Typography } from "@mui/material";

interface Props {
  label: string;
  children: ReactNode;
}

/** One read-only figure: a caption above a bold value. */
export function KeyFigure({ label, children }: Props) {
  return (
    <Paper variant="outlined" sx={{ p: 2, flex: 1, minWidth: 0 }}>
      <Typography variant="caption" color="text.secondary" component="div">
        {label}
      </Typography>
      <Box mt={0.5}>
        <Typography fontWeight="bold">{children}</Typography>
      </Box>
    </Paper>
  );
}
